import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}
export const ProductIconStromEco: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 236.1 188.1" style={{ color }} xmlSpace="preserve" fill="currentColor">
          <g>
      <defs>
        <path id="SVGID_1_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st0" style={{ clipPath: 'url(#SVGID_2_)' }}>
        <path d="M186.2,70c0-1.5-1.3-2.8-2.8-2.8s-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8S186.2,71.5,186.2,70L186.2,70 M192.4,70
          c0,4.9-4,8.9-8.9,8.9c-4.9,0-8.9-4-8.9-8.9c0-4.9,4-8.9,8.9-8.9l0,0C188.4,61.1,192.4,65.1,192.4,70" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_3_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_4_">
        <use xlinkHref="#SVGID_3_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st1" style={{ clipPath: 'url(#SVGID_4_)' }}>
        <path d="M183.4,57.1c1.2,0,2.3,0.2,3.4,0.5c1.7-7.9,2.6-16,2.6-24.1c-0.1-10.6-1.5-21.2-4.4-31.4c-0.3-0.9-1.2-1.4-2.1-1.1
          c-0.5,0.2-1,0.6-1.1,1.1c-2.9,10.2-4.3,20.8-4.4,31.4c0.1,8.1,0.9,16.2,2.6,24.1C181.1,57.3,182.3,57.1,183.4,57.1" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_5_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_6_">
        <use xlinkHref="#SVGID_5_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st2" style={{ clipPath: 'url(#SVGID_6_)' }}>
        <path d="M171,73.3c-17.9,5.7-34.2,15.8-47.2,29.4c-0.6,0.7-0.6,1.7,0,2.4c0.4,0.4,1,0.6,1.6,0.4c10.3-2.6,20.2-6.6,29.4-11.9
          c7-4.1,13.6-8.9,19.6-14.4C172.8,77.5,171.6,75.5,171,73.3" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_7_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_8_">
        <use xlinkHref="#SVGID_7_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st3" style={{ clipPath: 'url(#SVGID_8_)' }}>
        <path d="M243.1,102.7c-7.4-7.6-15.8-14.2-25-19.6c-7-4-14.5-7.3-22.2-9.8c-0.6,2.2-1.8,4.3-3.4,5.9c6,5.4,12.6,10.3,19.6,14.4
          c9.2,5.2,19.1,9.2,29.4,11.9c0.9,0.2,1.8-0.3,2-1.2C243.7,103.7,243.5,103.1,243.1,102.7" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_9_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_10_">
        <use xlinkHref="#SVGID_9_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st4" style={{ clipPath: 'url(#SVGID_10_)' }}>
        <path d="M183.4,83c-0.8,0-1.6-0.1-2.4-0.2l-5.1,109.6h14.9l-5.1-109.6C185,82.9,184.2,83,183.4,83" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_11_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_12_">
        <use xlinkHref="#SVGID_11_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st5" style={{ clipPath: 'url(#SVGID_12_)' }}>
        <path d="M104,120.4c0-1-0.9-1.9-1.9-1.9c-1,0-1.9,0.9-1.9,1.9c0,1,0.9,1.9,1.9,1.9S104,121.4,104,120.4L104,120.4 M108,120.4
          c0,3.3-2.6,5.9-5.9,5.9s-5.9-2.6-5.9-5.9c0-3.3,2.6-5.9,5.9-5.9c3.2,0,5.9,2.6,5.9,5.8C108,120.3,108,120.3,108,120.4" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_13_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_14_">
        <use xlinkHref="#SVGID_13_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st6" style={{ clipPath: 'url(#SVGID_14_)' }}>
        <path d="M102.1,111.8c0.8,0,1.5,0.1,2.3,0.3c1.2-5.3,1.8-10.7,1.8-16.1c-0.1-7.1-1.1-14.2-3-21c-0.2-0.6-0.8-0.9-1.4-0.8
          c-0.4,0.1-0.7,0.4-0.8,0.8c-1.9,6.8-2.9,13.9-3,21c0,5.4,0.6,10.8,1.8,16.1C100.6,111.9,101.3,111.8,102.1,111.8" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_15_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_16_">
        <use xlinkHref="#SVGID_15_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st7" style={{ clipPath: 'url(#SVGID_16_)' }}>
        <path d="M93.8,122.6c-5.1,1.6-10.1,3.8-14.8,6.5c-6.1,3.6-11.7,8-16.7,13c-0.4,0.5-0.4,1.2,0.1,1.6c0.3,0.3,0.7,0.4,1,0.3
          c6.8-1.8,13.4-4.4,19.6-7.9c4.7-2.7,9.1-6,13.1-9.6C95,125.4,94.2,124.1,93.8,122.6" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_17_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_18_">
        <use xlinkHref="#SVGID_17_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st8" style={{ clipPath: 'url(#SVGID_18_)' }}>
        <path d="M141.9,142.2c-4.9-5.1-10.6-9.4-16.7-13c-4.7-2.7-9.6-4.9-14.8-6.5c-0.4,1.5-1.2,2.8-2.3,3.9c4,3.6,8.4,6.8,13.1,9.6
          c6.1,3.5,12.7,6.2,19.6,7.9c0.6,0.1,1.2-0.2,1.4-0.9C142.3,142.8,142.2,142.4,141.9,142.2" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_19_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_20_">
        <use xlinkHref="#SVGID_19_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st9" style={{ clipPath: 'url(#SVGID_20_)' }}>
        <path d="M102.1,129c-0.5,0-1.1-0.1-1.6-0.1L97.1,202h10l-3.4-73.1C103.2,128.9,102.7,129,102.1,129" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_21_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_22_">
        <use xlinkHref="#SVGID_21_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st10" style={{ clipPath: 'url(#SVGID_22_)' }}>
        <path d="M30.3,149.4c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3C29.7,150.7,30.3,150.1,30.3,149.4
           M33.1,149.4c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2h0C31.2,145.2,33.1,147.1,33.1,149.4" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_23_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_24_">
        <use xlinkHref="#SVGID_23_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st11" style={{ clipPath: 'url(#SVGID_24_)' }}>
        <path d="M28.9,143.3c0.5,0,1.1,0.1,1.6,0.2c0.8-3.8,1.2-7.6,1.2-11.4c0-5-0.7-10-2.1-14.8c-0.1-0.4-0.5-0.7-0.9-0.6
          c-0.3,0.1-0.5,0.3-0.6,0.6c-1.3,4.8-2,9.8-2.1,14.8c0,3.8,0.4,7.6,1.2,11.4C27.8,143.4,28.3,143.3,28.9,143.3" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_25_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_26_">
        <use xlinkHref="#SVGID_25_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st12" style={{ clipPath: 'url(#SVGID_26_)' }}>
        <path d="M23.1,150.9c-3.6,1.2-7.2,2.7-10.5,4.6c-4.3,2.5-8.3,5.6-11.8,9.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.5,0.3,0.8,0.2
          c4.9-1.2,9.5-3.1,13.9-5.6c3.3-1.9,6.4-4.2,9.2-6.8C23.9,152.8,23.4,151.9,23.1,150.9" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_27_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_28_">
        <use xlinkHref="#SVGID_27_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st13" style={{ clipPath: 'url(#SVGID_28_)' }}>
        <path d="M57.1,164.7c-3.5-3.6-7.5-6.7-11.8-9.2c-3.3-1.9-6.9-3.4-10.5-4.6c-0.3,1.1-0.8,2-1.6,2.8c2.8,2.6,5.9,4.9,9.2,6.8
          c4.4,2.5,9,4.3,13.9,5.6c0.5,0.1,0.9-0.2,1-0.7C57.3,165.1,57.3,164.9,57.1,164.7" />
      </g>
    </g>
          <g>
      <defs>
        <path id="SVGID_29_" d="M2.8-72.3c-3.3-0.1-6,2.5-6.1,5.8c0,0,0,0,0,0v248.4c0.1,3.3,2.8,5.9,6.1,5.8c0,0,0,0,0,0h226.9
          c3.3,0.1,6-2.5,6.1-5.8c0,0,0,0,0,0V-66.5c-0.1-3.3-2.8-5.9-6.1-5.8c0,0,0,0,0,0L2.8-72.3z" />
      </defs>
            <clipPath id="SVGID_30_">
        <use xlinkHref="#SVGID_29_" style={{ overflow: 'visible' }} />
      </clipPath>
            <g className="st14" style={{ clipPath: 'url(#SVGID_30_)' }}>
        <path d="M28.9,155.4c-0.4,0-0.7,0-1.1-0.1l-2.4,51.6h7l-2.3-51.6C29.7,155.3,29.3,155.4,28.9,155.4" />
      </g>
    </g>
    </svg>
  );
}
